import styled from '@emotion/styled';
import { spacing, typography } from '$variables/theme';
import COLORS from '$variables/colors';

export const Container = styled.div`
  max-width: 646px;
  background-color: ${COLORS.white};
  border-radius: 4px;
  margin-bottom: ${spacing.xxLarge};
  padding: 50px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Icon = styled.span`
  font-size: 72px;
  margin-bottom: ${spacing.xLarge};
`;

export const Title = styled.div`
  color: ${COLORS.black};
  font-size: 22px;
  line-height: 28px;
  font-weight: ${typography.fontWeightSemiBold};
  text-align: center;
  margin-bottom: ${spacing.xSmall};
`;

export const SubTitle = styled.div`
  color: ${COLORS.grey1};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: ${spacing.xLarge};
`;
